import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueRollingPropertyUpdated = ({
  operator
}) => {
  const key = 'customerDataFiltersUI.customerDataFilters.DisplayValueRollingPropertyUpdated';
  if (typeof operator.numberOfDays !== 'number') {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: key,
    options: {
      count: operator.numberOfDays
    }
  });
};
export default DisplayValueRollingPropertyUpdated;